<template>
<div>
  <vue-headful
        :title="company.name + ' - Fernando Mata'"
      />
      <article class="post">
          <section class="companyHeader">
            <a :href="company.companyInformation.website" target=":blank">
              <img class="companyImage" :src="'/companies/'+ company.urlPath + '/' + company.logo">
            </a>
            <div class="headLine">
                <h1>{{company.name}}</h1>
            </div>
        </section>
        <hr>
        <section id="basicInformation" :class="mq == 'tiny' ? 'column' : '' ">
          <div class="information">
          <h3>{{$t("companyDetail.position")}}: {{company.role}}</h3>
          <h4>{{$t("companyDetail.location")}}: {{company.location}}</h4>
          </div>
          <div class="information" :class="mq == 'tiny' ? 'column' : '' " id="dates">
          <p>{{$t("companyDetail.joinedAt")}}: {{$d(new Date(company.joinedAt), 'condensed')}}</p>
          <p v-if="company.leftAt">{{$t("companyDetail.leftAt")}}: {{$d(new Date(company.leftAt), 'condensed')}}</p>
          </div>
          </section>
          <section id="myIntro">
            <p>{{company.description}}</p>
          </section>
          <section id="projects">
            <div v-for="project in company.projects" :key="project.name">
              <h2>{{project.name}}</h2>
              <img v-if="project.images" :src="'/companies/' + project.images[0]" />
            </div>
          </section>
      </article>
</div>
</template>

<script>
import { Trans } from '../localization/Translation.js'
import Experiences from '../data/Experience.json'

export default {
  computed: {
    mq() {
      return this.$mq
    },
    company() {
      return Experiences[Trans.currentLanguage].find((a) => a.urlPath == this.$route.params.company)
    }
  }
}
</script>

<style scoped>
  .companyHeader {
        display: flex;
        align-items: center;
        justify-content: left;
        flex-wrap: wrap;
    }
    .companyImage {
        height: 2rem;
        margin-right: 1rem;
    }
    .companyHeader .headLine {
        display: inline-block;
    }
    .headLine {
        margin-bottom: 0px;
    }
    .headLine h1 {
        display: block;
        margin-bottom: -6px;
    }
    .headLine h4 {
        color: #969696;
        margin-bottom: 0;
    }
    hr {
        margin-top: 16px;
        margin-bottom: 32px;
    }
    .companyHeader a {
      text-decoration: none;
      border: none;
      display: flex;
   }
   #basicInformation {
     display: flex;
     justify-content: space-between;
     align-items: left;
     flex-direction: row;
     flex-wrap: wrap;
     padding-bottom: 1rem;
   }
   #basicInformation.column {
     flex-direction: column;
     display: flex;
     justify-content: space-between;
     align-items: flex-start;
     flex-wrap: wrap;
   }
   #basicInformation h1,h2,h3,h4 {
     margin-bottom: auto;
   }
   #dates {
     display: flex;
     justify-content: space-between;
     align-items: flex-end;
     flex-direction: column;
     flex-wrap: wrap;
     padding-bottom: 1rem;
   }
   #dates.column {
     justify-content: space-between;
     align-items: flex-start;
     margin-left: 0;
   }
   #dates p {
     font-size: 0.7rem;
     padding-bottom: 0;
     margin-bottom: auto;
   }
   #projects {
     display: flex;
     justify-content: flex-start;
     align-items: center;
     flex-direction: column;
     flex-wrap: wrap;
     padding-bottom: 1rem;
   }
   #projects img {
     align-content: center;
     max-width: 50%;
     display: block;
   }
</style>


